module.exports = __webpack_public_path__ + "static/50-img-1-d6fa77b89a328f369b1bf69598748132.jpg";